// @spec DHB-STR-034
'use client';

import { createFileRoute } from '@tanstack/react-router';

import { ApprovalConfigPage } from '@/features/datahub/governance/ApprovalConfigPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/datahub/governance/approval-config')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.approvalWorkflowConfiguration'),
  }),
  component: ApprovalConfigPage,
});
